import { DateTime } from 'luxon';

import { AiThreadResponseQl } from '../../../../data/smart-search/hooks';
import { encodeRecipeJSON } from '../../../../dtos/own/recipeHelpers';
import { SemboMarket } from '../../../../utils/markets';
import { DestinationDetails } from './Amelia.types';

export const getUrlWithJsonRecipe = (
  market: SemboMarket,
  recipe: string,
  aiTripId: string | null | undefined,
  day: string | undefined
): string => {
  const url = new URL('/travel/plan/', `https://${market.host}`);

  url.searchParams.append(
    'recipe',
    encodeRecipeJSON(recipe, { skipSessionPax: true })
  );

  if (aiTripId) {
    url.searchParams.append('ai-trip-id', aiTripId);
  }

  if (day) {
    url.searchParams.append('day', day);
  }

  return url.toString();
};

export const getValidSelectedDay = (
  day: string | null | undefined
): string | undefined => {
  if (!day) {
    return;
  }

  const now = DateTime.now().startOf('day');
  const selectedDate = DateTime.fromISO(day).startOf('day');

  if (!selectedDate.isValid || selectedDate < now) {
    return;
  }

  return day;
};

export const createDestinations = (
  result: AiThreadResponseQl
): DestinationDetails[] => {
  const destinationDetails: DestinationDetails[] = [];

  if (result.additionalTexts?.destinations?.length) {
    try {
      const recipe = JSON.parse(result.recipeJson ?? '{}');
      if (
        recipe.ingredients?.length &&
        recipe.ingredients?.length ===
          result.additionalTexts?.destinations?.length
      ) {
        result.additionalTexts.destinations.forEach((destination, i) => {
          if (destination) {
            destinationDetails.push({
              name: destination.name as string,
              activities: destination.activityTexts as string[],
              numberOfNights: recipe.ingredients[i].numberOfNights,
            });
          }
        });
      }
    } catch (e) {
      // invalid recipeJson prop
    }
  }

  return destinationDetails;
};
